/* eslint-disable */
export default {
  _dinoriffic: 'dinoriffic',
  _math_lines_instructions_2: 'math_lines_instructions_2',
  _math_lines_multi_instruction: 'math_lines_multi_instruction',
  _math_lines_multi_select_instructions: 'math_lines_multi_select_instructions',
  _math_lines_multi_title: 'math_lines_multi_title',
}